import { errorCodeMapper, getErrorMessage } from "./firebase/ErrorCodeMapper";

function localeStringDate(date: { seconds: number}) : Date {
    return new Date(date.seconds * 1000);
}


export {
    errorCodeMapper, getErrorMessage, localeStringDate
}